import { Component } from "@angular/core";
import { LayoutService } from "../../../../shared/services/layout.service";
import { CommonSvgIconComponent } from "../../common-svg-icon/common-svg-icon.component";
import { localStorageConstants } from "../../../../consts/local_storage_constants";

@Component({
  selector: "app-theme-mode",
  templateUrl: "./theme-mode.component.html",
  imports: [CommonSvgIconComponent],
  styleUrls: ["./theme-mode.component.scss"]
})
export class ThemeModeComponent {

  public dark: boolean = this.layout.config.settings.layout_version == "dark-only" ? true : false;

  constructor(public layout: LayoutService) {
    const themeType = localStorage.getItem(localStorageConstants.THEME_TYPE);
    if (themeType != null) {
      if (themeType == 'Light') {
        localStorage.setItem(localStorageConstants.THEME_TYPE, 'Light');
        this.dark = false;
        this.layout.config.settings.layout_version = "light";
        document.body.classList.add("light");
      } else {
        localStorage.setItem(localStorageConstants.THEME_TYPE, 'Dark');
        this.dark = true;
        this.layout.config.settings.layout_version = "dark-only";
        document.body.classList.add("dark-only");
      }
    } else {
      localStorage.setItem(localStorageConstants.THEME_TYPE, 'Light');
      this.layout.config.settings.layout_version = "light";
      document.body.classList.add("light");
    }
  }

  layoutToggle() {
    this.dark = !this.dark;
    this.dark ? document.body.classList.add("dark-only") : document.body.classList.remove("dark-only");
    this.layout.config.settings.layout_version = this.dark ? "dark-only" : "light";
    if (this.layout.config.settings.layout_version == "dark-only") {
      localStorage.setItem(localStorageConstants.THEME_TYPE, 'Dark');
    } else {
      localStorage.setItem(localStorageConstants.THEME_TYPE, 'Light');
    }
  }
}
